var CURRENCY_SYMBOLS = {
    ALL: '\u004c\u0065\u006b',
    AFN: '\u060b',
    ARS: '\u0024',
    AWG: '\u0192',
    AUD: '\u0041\u0024',
    AZN: '\u20bc',
    BSD: '\u0024',
    BBD: '\u0024',
    BYN: '\u0042\u0059\u004e',
    BZD: '\u0042\u005a\u0024',
    BMD: '\u0024',
    BOB: '\u0024\u0062',
    BOV: '\u0024\u0062',
    BAM: '\u004b\u004d',
    BWP: '\u0050',
    BGN: '\u0042\u0047\u004e',
    BRL: '\u0052\u0024',
    BND: '\u0024',
    KHR: '\u17db',
    CAD: '\u0043\u0024',
    KYD: '\u0024',
    CLP: '\u0024',
    CNY: '\u04b0',
    COP: '\u0024',
    COU: '\u0024',
    CRC: '\u20a1',
    HRK: '\u0048\u0052\u004b',
    CUP: '\u20b1',
    CUC: '\u20b1',
    CZK: '\u004b\u010d',
    DKK: '\u0044\u004b\u004b',
    DOP: '\u0052\u0044\u0024',
    XCD: '\u0024',
    EGP: '\u00a3',
    SVC: '\u0024',
    EEK: '\u0045\u0045\u004b',
    EUR: '\u20ac',
    FKP: '\u00a3',
    FJD: '\u0024',
    FRF: '\u20a3',
    GHC: '\u00a2',
    GIP: '\u00a3',
    GTQ: '\u0051',
    GGP: '\u00a3',
    GYD: '\u0024',
    HNL: '\u004c',
    HKD: '\u0048\u004b\u0024',
    HUF: '\u0046\u0074',
    ISK: '\u006b\u0072',
    INR: '\u20b9',
    IDR: '\u0052\u0070',
    IRR: '\ufdfc',
    IMP: '\u00a3',
    ILS: '\u20aa',
    JMD: '\u004a\u0024',
    JPY: '\u00a5',
    JEP: '\u00a3',
    KZT: '\u20B8',
    KGS: '\u004B\u0047\u0053',
    LAK: '\u20ad',
    LVL: '\u004c\u0073',
    LBP: '\u00a3',
    LRD: '\u0024',
    LTL: '\u004c\u0074',
    MKD: '\u0434\u0435\u043d',
    MYR: '\u004d\u0059\u0052',
    MUR: '\u20a8',
    MXN: '\u004d\u0058\u0024',
    MXV: '\u0024',
    MNT: '\u20ae',
    MZN: '\u004d\u0054',
    NAD: '\u0024',
    NPR: '\u20a8',
    ANG: '\u0192',
    NZD: '\u004e\u005a\u0024',
    NIO: '\u0043\u0024',
    NGN: '\u20a6',
    KPW: '\u20a9',
    NOK: '\u006b\u0072',
    OMR: '\ufdfc',
    PKR: '\u20a8',
    PAB: '\u0042\u002f\u002e',
    PYG: '\u0047\u0073',
    PEN: '\u0053\u002f\u002e',
    PHP: '\u20b1',
    PLN: '\u007a\u0142',
    QAR: '\ufdfc',
    RON: '\u006c\u0065\u0069',
    RUR: '\u20bd',
    RUB: '\u20bd',
    SHP: '\u00a3',
    SAR: '\ufdfc',
    RSD: '\u0414\u0438\u043d\u002e',
    SCR: '\u20a8',
    SGD: '\u0053\u0024',
    SBD: '\u0024',
    SOS: '\u0053',
    ZAR: '\u005a\u0041\u0052',
    KRW: '\u20a9',
    LKR: '\u20a8',
    SEK: '\u0053\u0045\u004b',
    CHF: '\u20a3',
    SRD: '\u0024',
    SYP: '\u00a3',
    TWD: '\u004e\u0054\u0024',
    THB: '\u0e3f',
    TTD: '\u0054\u0054\u0024',
    TRY: '\u20ba',
    TRL: '\u20ba',
    TVD: '\u0024',
    UAH: '\u20b4',
    GBP: '\u00a3',
    USD: '\u0024',
    UYU: '\u0024\u0055',
    UYI: '\u0024\u0055',
    UZS: '\u0055\u005a\u0053',
    VEF: '\u0042\u0073',
    VND: '\u20ab',
    YER: '\ufdfc',
    ZWD: '\u005a\u0024',
    A98: '\u0433',
    A99: '\u0433',
    A76: '\u0433',
    A33: '\u0433',
    AMD: '\u0041\u004d\u0044',
    BDT: '\u09f3',
    BIF: '\u20a3',
    GEL: '\u20BE',
    GHS: '\u20B5',
    SDG: '\u00A3',
    TJS: '\u0054\u004a\u0053',
    KWD: '\u004b\u0057\u0044',
    MDL: '\u004d\u0044\u004c',
    AED: '\u0041\u0045\u0044',
};
var currency = {
    CURRENCY_SYMBOLS: CURRENCY_SYMBOLS,
};

/* eslint comma-dangle: 0 */
var countries = [
    ['Afghanistan', 'Афганистан', 'af', '93'],
    ['Albania', 'Албания', 'al', '355'],
    ['Algeria', 'Алжир', 'dz', '213'],
    ['American Samoa', 'Американское Самоа', 'as', '1684'],
    ['Andorra', 'Андорра', 'ad', '376'],
    ['Angola', 'Ангола', 'ao', '244'],
    ['Anguilla', 'Ангилья', 'ai', '1264'],
    ['Antigua and Barbuda', 'Антигуа и Барбуда', 'ag', '1268'],
    ['Argentina', 'Аргентина', 'ar', '54'],
    ['Armenia', 'Армения', 'am', '374'],
    ['Aruba', 'Аруба', 'aw', '297'],
    ['Australia', 'Австралия', 'au', '61', 0],
    ['Austria', 'Австрия', 'at', '43'],
    ['Azerbaijan', 'Азербайджан', 'az', '994'],
    ['Bahamas', 'Багамские Острова', 'bs', '1242'],
    ['Bahrain', 'Бахрейн', 'bh', '973'],
    ['Bangladesh', 'Бангладеш', 'bd', '880'],
    ['Barbados', 'Барбадос', 'bb', '1246'],
    ['Belarus', 'Беларусь', 'by', '375'],
    ['Belgium', 'Бельгия', 'be', '32'],
    ['Belize', 'Белиз', 'bz', '501'],
    ['Benin', 'Бенин', 'bj', '229'],
    ['Bermuda', 'Бермудские Острова', 'bm', '1441'],
    ['Bhutan', 'Бутан', 'bt', '975'],
    ['Bolivia', 'Боливия', 'bo', '591'],
    ['Bosnia and Herzegovina', 'Босния и Герцеговина', 'ba', '387'],
    ['Botswana', 'Ботсвана', 'bw', '267'],
    ['Brazil', 'Бразилия', 'br', '55'],
    ['British Indian Ocean Territory', 'Брит. Терр. в Индийском Океане', 'io', '246'],
    ['British Virgin Islands', 'Британские Виргинские Острова', 'vg', '1284'],
    ['Brunei', 'Бруней', 'bn', '673'],
    ['Bulgaria', 'Болгария', 'bg', '359'],
    ['Burkina Faso', 'Буркина-Фасо', 'bf', '226'],
    ['Burundi', 'Бурунди', 'bi', '257'],
    ['Cambodia', 'Камбоджа', 'kh', '855'],
    ['Cameroon', 'Камерун', 'cm', '237'],
    [
        'Canada',
        'Канада',
        'ca',
        '1',
        1,
        [
            '204',
            '226',
            '236',
            '249',
            '250',
            '289',
            '306',
            '343',
            '365',
            '387',
            '403',
            '416',
            '418',
            '431',
            '437',
            '438',
            '450',
            '506',
            '514',
            '519',
            '548',
            '579',
            '581',
            '587',
            '604',
            '613',
            '639',
            '647',
            '672',
            '705',
            '709',
            '742',
            '778',
            '780',
            '782',
            '807',
            '819',
            '825',
            '867',
            '873',
            '902',
            '905',
        ],
    ],
    ['Cape Verde', 'Кабо-Верде', 'cv', '238'],
    ['Caribbean Netherlands', 'Карибские Нидерланды', 'bq', '599', 1],
    ['Cayman Islands', 'Каймановы Острова', 'ky', '1345'],
    ['Central African Republic', 'ЦАР', 'cf', '236'],
    ['Chad', 'Чад', 'td', '235'],
    ['Chile', 'Чили', 'cl', '56'],
    ['China', 'Китайская Народная Республика', 'cn', '86'],
    ['Christmas Island (Australia)', 'Остров Рождества', 'cx', '61', 2],
    ['Cocos (Keeling) Islands', 'Кокосовые Острова', 'cc', '61', 1],
    ['Colombia', 'Колумбия', 'co', '57'],
    ['Comoros', 'Коморские Острова', 'km', '269'],
    ['Congo (DRC)', 'Демократическая Республика Конго', 'cd', '243'],
    ['Congo (Republic)', 'Республика Конго', 'cg', '242'],
    ['Cook Islands', 'Острова Кука', 'ck', '682'],
    ['Costa Rica', 'Коста-Рика', 'cr', '506'],
    ['Côte d’Ivoire', 'Кот-д’Ивуар', 'ci', '225'],
    ['Croatia', 'Хорватия', 'hr', '385'],
    ['Cuba', 'Куба', 'cu', '53'],
    ['Curaçao', 'Кюрасао', 'cw', '599', 0],
    ['Cyprus', 'Кипр', 'cy', '357'],
    ['Czech Republic', 'Чехия', 'cz', '420'],
    ['Denmark', 'Дания', 'dk', '45'],
    ['Djibouti', 'Джибути', 'dj', '253'],
    ['Dominica', 'Доминика', 'dm', '1767'],
    ['Dominican Republic', 'Доминиканская Республика', 'do', '1', 2, ['809', '829', '849']],
    ['Ecuador', 'Эквадор', 'ec', '593'],
    ['Egypt', 'Египет', 'eg', '20'],
    ['El Salvador', 'Сальвадор', 'sv', '503'],
    ['Equatorial Guinea', 'Экваториальная Гвинея', 'gq', '240'],
    ['Eritrea', 'Эритрея', 'er', '291'],
    ['Estonia', 'Эстония', 'ee', '372'],
    ['Ethiopia', 'Эфиопия', 'et', '251'],
    ['Falkland Islands', 'Фолклендские Острова', 'fk', '500'],
    ['Faroe Islands', 'Фарерские Острова', 'fo', '298'],
    ['Fiji', 'Фиджи', 'fj', '679'],
    ['Finland', 'Финляндия', 'fi', '358', 0],
    ['France', 'Франция', 'fr', '33'],
    ['French Guiana', 'Гвиана Французская', 'gf', '594'],
    ['French Polynesia', 'Полинезия Французская', 'pf', '689'],
    ['Gabon', 'Габон', 'ga', '241'],
    ['Gambia', 'Гамбия', 'gm', '220'],
    ['Georgia', 'Грузия', 'ge', '995'],
    ['Germany', 'Германия', 'de', '49'],
    ['Ghana', 'Гана', 'gh', '233'],
    ['Gibraltar', 'Гибралтар', 'gi', '350'],
    ['Greece', 'Греция', 'gr', '30'],
    ['Greenland', 'Гренландия', 'gl', '299'],
    ['Grenada', 'Гренада', 'gd', '1473'],
    ['Guadeloupe', 'Гваделупа', 'gp', '590', 0],
    ['Guam', 'Гуам', 'gu', '1671'],
    ['Guatemala', 'Гватемала', 'gt', '502'],
    ['Guernsey', 'Гернси', 'gg', '44', 1],
    ['Guinea', 'Гвинея', 'gn', '224'],
    ['Guinea-Bissau', 'Гвинея-Бисау', 'gw', '245'],
    ['Guyana', 'Гайана', 'gy', '592'],
    ['Haiti', 'Гаити', 'ht', '509'],
    ['Honduras', 'Гондурас', 'hn', '504'],
    ['Hong Kong', 'Гонконг', 'hk', '852'],
    ['Hungary', 'Венгрия', 'hu', '36'],
    ['Iceland', 'Исландия', 'is', '354'],
    ['India', 'Индия', 'in', '91'],
    ['Indonesia', 'Индонезия', 'id', '62'],
    ['Iran', 'Иран', 'ir', '98'],
    ['Iraq', 'Ирак', 'iq', '964'],
    ['Ireland', 'Ирландия', 'ie', '353'],
    ['Isle of Man', 'Остров Мэн', 'im', '44', 2],
    ['Israel', 'Израиль', 'il', '972'],
    ['Italy', 'Италия', 'it', '39', 0],
    ['Jamaica', 'Ямайка', 'jm', '1876'],
    ['Japan', 'Япония', 'jp', '81'],
    ['Jersey', 'Джерси', 'je', '44', 3],
    ['Jordan', 'Иордания', 'jo', '962'],
    ['Kazakhstan', 'Казахстан', 'kz', '7', 1],
    ['Kenya', 'Кения', 'ke', '254'],
    ['Kiribati', 'Кирибати', 'ki', '686'],
    ['Kosovo', 'Косово', 'xk', '383'],
    ['Kuwait', 'Кувейт', 'kw', '965'],
    ['Kyrgyzstan', 'Киргизия', 'kg', '996'],
    ['Laos', 'Лаос', 'la', '856'],
    ['Latvia', 'Латвия', 'lv', '371'],
    ['Lebanon', 'Ливан', 'lb', '961'],
    ['Lesotho', 'Лесото', 'ls', '266'],
    ['Liberia', 'Либерия', 'lr', '231'],
    ['Libya', 'Ливия', 'ly', '218'],
    ['Liechtenstein', 'Лихтенштейн', 'li', '423'],
    ['Lithuania', 'Литва', 'lt', '370'],
    ['Luxembourg', 'Люксембург', 'lu', '352'],
    ['Macau', 'Макао', 'mo', '853'],
    ['Macedonia', 'Македония', 'mk', '389'],
    ['Madagascar', 'Мадагаскар', 'mg', '261'],
    ['Malawi', 'Малави', 'mw', '265'],
    ['Malaysia', 'Малайзия', 'my', '60'],
    ['Maldives', 'Мальдивы', 'mv', '960'],
    ['Mali', 'Мали', 'ml', '223'],
    ['Malta', 'Мальта', 'mt', '356'],
    ['Marshall Islands', 'Маршалловы Острова', 'mh', '692'],
    ['Martinique', 'Мартиника', 'mq', '596'],
    ['Mauritania', 'Мавритания', 'mr', '222'],
    ['Mauritius', 'Маврикий', 'mu', '230'],
    ['Mayotte', 'Майотта', 'yt', '262', 1],
    ['Mexico', 'Мексика', 'mx', '52'],
    ['Micronesia', 'Микронезия', 'fm', '691'],
    ['Moldova', 'Молдавия', 'md', '373'],
    ['Monaco', 'Монако', 'mc', '377'],
    ['Mongolia', 'Монголия', 'mn', '976'],
    ['Montenegro', 'Черногория', 'me', '382'],
    ['Montserrat', 'Монтсеррат', 'ms', '1664'],
    ['Morocco', 'Марокко', 'ma', '212', 0],
    ['Mozambique', 'Мозамбик', 'mz', '258'],
    ['Myanmar', 'Мьянма', 'mm', '95'],
    ['Namibia', 'Намибия', 'na', '264'],
    ['Nauru', 'Науру', 'nr', '674'],
    ['Nepal', 'Непал', 'np', '977'],
    ['Netherlands', 'Нидерланды', 'nl', '31'],
    ['New Caledonia', 'Новая Каледония', 'nc', '687'],
    ['New Zealand', 'Новая Зеландия', 'nz', '64'],
    ['Nicaragua', 'Никарагуа', 'ni', '505'],
    ['Niger', 'Нигер', 'ne', '227'],
    ['Nigeria', 'Нигерия', 'ng', '234'],
    ['Niue', 'Ниуэ', 'nu', '683'],
    ['Norfolk Island', 'Остров Норфолк', 'nf', '672'],
    ['North Korea', 'Северная Корея', 'kp', '850'],
    ['Northern Mariana Islands', 'Северные Марианские Острова', 'mp', '1670'],
    ['Norway', 'Норвегия', 'no', '47', 0],
    ['Oman', 'Оман', 'om', '968'],
    ['Pakistan', 'Пакистан', 'pk', '92'],
    ['Palau', 'Палау', 'pw', '680'],
    ['Palestine', 'Палестина', 'ps', '970'],
    ['Panama', 'Панама', 'pa', '507'],
    ['Papua New Guinea', 'Папуа — Новая Гвинея', 'pg', '675'],
    ['Paraguay', 'Парагвай', 'py', '595'],
    ['Peru', 'Перу', 'pe', '51'],
    ['Philippines', 'Филиппины', 'ph', '63'],
    ['Poland', 'Польша', 'pl', '48'],
    ['Portugal', 'Португалия', 'pt', '351'],
    ['Puerto Rico', 'Пуэрто-Рико', 'pr', '1', 3, ['787', '939']],
    ['Qatar', 'Катар', 'qa', '974'],
    ['Réunion', 'Реюньон', 're', '262', 0],
    ['Romania', 'Румыния', 'ro', '40'],
    ['Russia', 'Россия', 'ru', '7', 0],
    ['Rwanda', 'Руанда', 'rw', '250'],
    ['Saint Barthélemy', 'Сен-Бартелеми', 'bl', '590', 1],
    ['Saint Helena', 'Остров Святой Елены', 'sh', '290'],
    ['Saint Kitts and Nevis', 'Сент-Китс и Невис', 'kn', '1869'],
    ['Saint Lucia', 'Сент-Люсия', 'lc', '1758'],
    ['Saint Martin', 'Сен-Мартен', 'mf', '590', 2],
    ['Saint Pierre and Miquelon', 'Сен-Пьер и Микелон', 'pm', '508'],
    ['Saint Vincent and the Grenadines', 'Сент-Винсент и Гренадины', 'vc', '1784'],
    ['Samoa', 'Самоа', 'ws', '685'],
    ['San Marino', 'Сан-Марино', 'sm', '378'],
    ['São Tomé and Príncipe', 'Сан-Томе и Принсипи', 'st', '239'],
    ['Saudi Arabia', 'Саудовская Аравия', 'sa', '966'],
    ['Senegal', 'Сенегал', 'sn', '221'],
    ['Serbia', 'Сербия', 'rs', '381'],
    ['Seychelles', 'Сейшельские Острова', 'sc', '248'],
    ['Sierra Leone', 'Сьерра-Леоне', 'sl', '232'],
    ['Singapore', 'Сингапур', 'sg', '65'],
    ['Sint Maarten', 'Синт-Мартен', 'sx', '1721'],
    ['Slovakia', 'Словакия', 'sk', '421'],
    ['Slovenia', 'Словения', 'si', '386'],
    ['Solomon Islands', 'Соломоновы Острова', 'sb', '677'],
    ['Somalia', 'Сомали', 'so', '252'],
    ['South Africa', 'ЮАР', 'za', '27'],
    ['South Korea', 'Южная Корея', 'kr', '82'],
    ['South Sudan', 'Южный Судан', 'ss', '211'],
    ['Spain', 'Испания', 'es', '34'],
    ['Sri Lanka', 'Шри-Ланка', 'lk', '94'],
    ['Sudan', 'Судан', 'sd', '249'],
    ['Suriname', 'Суринам', 'sr', '597'],
    ['Svalbard and Jan Mayen', 'Шпицберген и Ян-Майен', 'sj', '47', 1],
    ['Swaziland', 'Свазиленд', 'sz', '268'],
    ['Sweden', 'Швеция', 'se', '46'],
    ['Switzerland', 'Швейцария', 'ch', '41'],
    ['Syria', 'Сирия', 'sy', '963'],
    ['Taiwan', 'Тайвань', 'tw', '886'],
    ['Tajikistan', 'Таджикистан', 'tj', '992'],
    ['Tanzania', 'Танзания', 'tz', '255'],
    ['Thailand', 'Таиланд', 'th', '66'],
    ['Timor-Leste', 'Восточный Тимор', 'tl', '670'],
    ['Togo', 'Того', 'tg', '228'],
    ['Tokelau', 'Токелау', 'tk', '690'],
    ['Tonga', 'Тонга', 'to', '676'],
    ['Trinidad and Tobago', 'Тринидад и Тобаго', 'tt', '1868'],
    ['Tunisia', 'Тунис', 'tn', '216'],
    ['Turkey', 'Турция', 'tr', '90'],
    ['Turkmenistan', 'Туркмения', 'tm', '993'],
    ['Turks and Caicos Islands', 'Тёркс и Кайкос', 'tc', '1649'],
    ['Tuvalu', 'Тувалу', 'tv', '688'],
    ['U.S. Virgin Islands', 'Американские Виргинские Острова', 'vi', '1340'],
    ['Uganda', 'Уганда', 'ug', '256'],
    ['Ukraine', 'Украина', 'ua', '380'],
    ['United Arab Emirates', 'ОАЭ', 'ae', '971'],
    ['United Kingdom', 'Великобритания', 'gb', '44', 0],
    ['United States', 'США', 'us', '1', 0],
    ['Uruguay', 'Уругвай', 'uy', '598'],
    ['Uzbekistan', 'Узбекистан', 'uz', '998'],
    ['Vanuatu', 'Вануату', 'vu', '678'],
    ['Vatican City', 'Ватикан', 'va', '39', 1],
    ['Venezuela', 'Венесуэла', 've', '58'],
    ['Vietnam', 'Вьетнам', 'vn', '84'],
    ['Wallis and Futuna', 'Уоллис и Футуна', 'wf', '681'],
    ['Western Sahara', 'Западная Сахара', 'eh', '212', 1],
    ['Yemen', 'Йемен', 'ye', '967'],
    ['Zambia', 'Замбия', 'zm', '260'],
    ['Zimbabwe', 'Зимбабве', 'zw', '263'],
    ['Åland Islands', 'Аландские Острова', 'ax', '358', 1],
];

var keyboardCodes = {
    SPACE: 32,
    BACKSPACE: 8,
    TAB: 9,
    ENTER: 13,
    SHIFT: 16,
    CTRL: 17,
    ALT: 18,
    PAUSE_BREAK: 19,
    CAPS_LOCK: 20,
    ESCAPE: 27,
    PAGE_UP: 33,
    PAGE_DOWN: 34,
    END: 35,
    HOME: 36,
    LEFT_ARROW: 37,
    UP_ARROW: 38,
    RIGHT_ARROW: 39,
    DOWN_ARROW: 40,
    INSERT: 45,
    DELETE: 46,
    NUMBER_0: 48,
    NUMBER_1: 49,
    NUMBER_2: 50,
    NUMBER_3: 51,
    NUMBER_4: 52,
    NUMBER_5: 53,
    NUMBER_6: 54,
    NUMBER_7: 55,
    NUMBER_8: 56,
    NUMBER_9: 57,
    LETTER_A: 65,
    LETTER_B: 66,
    LETTER_C: 67,
    LETTER_D: 68,
    LETTER_E: 69,
    LETTER_F: 70,
    LETTER_G: 71,
    LETTER_H: 72,
    LETTER_I: 73,
    LETTER_J: 74,
    LETTER_K: 75,
    LETTER_L: 76,
    LETTER_M: 77,
    LETTER_N: 78,
    LETTER_O: 79,
    LETTER_P: 80,
    LETTER_Q: 81,
    LETTER_R: 82,
    LETTER_S: 83,
    LETTER_T: 84,
    LETTER_U: 85,
    LETTER_V: 86,
    LETTER_W: 87,
    LETTER_X: 88,
    LETTER_Y: 89,
    LETTER_Z: 90,
    LEFT_WINDOW_KEY: 91,
    RIGHT_WINDOW_KEY: 92,
    SELECT_KEY: 93,
    NUMPAD_0: 96,
    NUMPAD_1: 97,
    NUMPAD_2: 98,
    NUMPAD_3: 99,
    NUMPAD_4: 100,
    NUMPAD_5: 101,
    NUMPAD_6: 102,
    NUMPAD_7: 103,
    NUMPAD_8: 104,
    NUMPAD_9: 105,
    MULTIPLY: 106,
    ADD: 107,
    SUBTRACT: 109,
    DECIMALPOINT: 110,
    DIVIDE: 111,
    F1: 112,
    F2: 113,
    F3: 114,
    F4: 115,
    F5: 116,
    F6: 117,
    F7: 118,
    F8: 119,
    F9: 120,
    F10: 121,
    F11: 122,
    F12: 123,
    NUM_LOCK: 144,
    SCROLL_LOCK: 145,
    SEMI_COLON: 186,
    EQUAL_SIGN: 187,
    COMMA: 188,
    DASH: 189,
    PERIOD: 190,
    FORWARD_SLASH: 191,
    GRAVE_ACCENT: 192,
    OPEN_BRACKET: 219,
    BACK_SLASH: 220,
    CLOSE_BRACKET: 221,
    SINGLE_QUOTE: 222,
};

export { countries, currency, keyboardCodes };
